import { useEffect, useState } from "react";

const FAB_DEFAULT_TOP = 96;
const FAB_HEADER_GAP = 12;

export default function useFabTop() {
  const [top, setTop] = useState(FAB_DEFAULT_TOP);

  useEffect(() => {
    const header = document.querySelector("[data-matematron-main-header]");
    if (!header) return undefined;

    let frame = null;
    const update = () => {
      if (frame != null) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        frame = null;
        const headerBottom = header.getBoundingClientRect().bottom;
        setTop(Math.max(FAB_DEFAULT_TOP, headerBottom + FAB_HEADER_GAP));
      });
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    const resizeObserver =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(update) : null;
    resizeObserver?.observe(header);

    return () => {
      if (frame != null) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      resizeObserver?.disconnect();
    };
  }, []);

  return top;
}
